import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { t, translate } from 'react-switch-lang';
import { useSelector } from 'react-redux';
import { Dropdown } from 'react-bootstrap';

import './NavBar.scss';
import { brandConfig as allBrands, getFontColor, getLogoDisplayText, getLogoDisplayTextColor, languageText } from '../../configurations/Brands';
import { replaceLinkLanguage } from '../../helperFunctions/LinkGenerator';
import { event, logAmpEvent } from '../../helperFunctions/Amplitude';
import usingIE from '../../helperFunctions/UsingIE';

function Navbar() {
  const { brand, lang } = useSelector((state) => state);
  const [showDropDown, setShowDropDown] = useState(false);

  const curLang = lang;
  const brandConfig = allBrands[brand];
  const link = t(brandConfig.text.navBar.link);

  const showLanguageDropdown = allBrands[brand].languages.length > 1;

  let ieStyle;
  if (usingIE()) {
    ieStyle = {
      padding: '10px',
      paddingLeft: '5px',
      marginTop: '-20px',
    };
  }

  const contactUsLink = () => ((brand !== 'canadapost-singleloadprepaid') ? (
    <li className="nav-item" style={ieStyle}>
      <Link
        className="nav-item cust-contact-btn"
        to={`/${brand}/${curLang}/contactus`}
        style={{ color: getFontColor(brand) }}
        onClick={() => {
          logAmpEvent(event.USER_CLICKED_NAVBAR_CONTACT_US);
        }}
      >
        <span style={{ color: getFontColor(brand) }}>
          {t('General_Contact_Us')}
        </span>
      </Link>
    </li>
  ) :
    null);

  const paySimplyCheckPaymentLink = () => (
    (brand === 'paysimply') && (
      <li className="nav-item" style={ieStyle}>
        <a
          href={`${t('Link_PaySimply_MyPayment')}?utm_source=help-centre`}
          aria-label={t('Navbar_Paysimply_CheckPaymentStatus')}
          style={{ color: getFontColor(brand) }}
        >
          {t('Navbar_Paysimply_CheckPaymentStatus')}
        </a>
      </li>
    )
  );

  // Returns a link for dropdown and nav bar if brandConfig[brand].text.navbar.text exists
  const brandDynamicLink = () => {
    if (brandConfig.text.navBar.text === '') return '';
    return (
      <li className="nav-item" style={ieStyle}>
        <a
          className="cust-nav-link"
          style={{ color: getFontColor(brand) }}
          href={link}
          target="_blank"
          rel="noreferrer"
        >
          {t(brandConfig.text.navBar.text)}
        </a>
      </li>
    );
  };

  return (
    <>
      <div id="top-of-page" />
      {!brandConfig ? (
        // default NavBar
        <nav
          className="navbar navbar-expand-lg"
          style={{
            backgroundColor: '#232222',
            height: 40,
          }}
        />
      ) : (
        <nav
          className={`navbar navbar-expand-lg ${brand} ${brandConfig.theme.navclass}`}
          style={{ backgroundColor: brandConfig.theme.bkgColor }}
        >

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => logAmpEvent(event.USER_CLICKED_HAMBURGER)}
          >
            <span className="navbar-toggler-icon" />
          </button>
          <Link
            id="navbar-branding"
            to={`/${brand}/${curLang}/categories`}
            aria-label={brandConfig.theme.logoAltText}
            onClick={() => logAmpEvent(event.USER_CLICKED_NAVBAR_HOME_ICON)}
          >
            <img
              id="navbar-logo"
              src={brandConfig.theme.logo}
              alt={brandConfig.theme.logoAltText}
            />
            <span id="navbarLogoText" style={{ color: getLogoDisplayTextColor(brand) }}>{getLogoDisplayText(brand)}</span>
          </Link>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className={`navbar-nav ${brandConfig.theme.langnumber}`}>
              {brandDynamicLink()}
              {paySimplyCheckPaymentLink()}
              {showLanguageDropdown && (
                <li>
                  <Dropdown
                    className="nav-item"
                    onMouseEnter={() => setShowDropDown(true)}
                    onToggle={(nextShow) => setShowDropDown(nextShow)}
                    onMouseLeave={() => setShowDropDown(false)}
                    show={showDropDown}
                  >
                    <Dropdown.Toggle
                      id="navbarDropdown"
                      className="dynamic-color"
                      style={{ '--brand-color': getFontColor(brand) }}
                    >
                      <span>{t('Navbar_Language')}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {allBrands[brand].languages.map((brandLang) => (
                        <Dropdown.Item
                          href={replaceLinkLanguage(brandLang)}
                          lang={brandLang}
                          className={`language-dropdown-item${
                            brandLang === curLang ? ' selectedLanguage' : ''
                          }`}
                          tabIndex={showDropDown ? undefined : -1}
                        >
                          {languageText[brandLang]}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              )}
              {contactUsLink()}
            </ul>
          </div>
        </nav>
      )}
    </>
  );
}

export default translate(Navbar);
